import React, { useState, useEffect } from "react";
import headerLogoImage from "../../assets/image/headerLogoImage.png";
import Footer from "../../components/Footer";
import CircleTwoToneIcon from '@mui/icons-material/CircleTwoTone';

const ReportPage = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Retrieve the data from sessionStorage
    const storedData = sessionStorage.getItem("resultsData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setData(parsedData.data); 
       sessionStorage.removeItem("fytn_token");
    }
  }, []);

  const handleRedirectButton = () => {
    window.location.href = "/test";
  };

  if (!data) {
    return <p>No data available. Please complete the test first.</p>;
  }

  return (
    <>
      <header className=" app-header-css App-header">
        <img src={headerLogoImage} alt="Logo" className="App-logo" />
        <button
          type="button"
          onClick={handleRedirectButton}
          className="vip-button rounded-md w-[180px]"
        >
          Take Your VIP Test
        </button>
      </header>
            
            <div className="container mx-auto justify-center items-center px-6 py-8">
        <h1
            className="question-header text-gray-800 text-left mb-12"
            style={{
            marginTop: "100px",
            }}
        >
            This minute report consists of the essential information needed to get
            started. Your North report is accurate and precise and will help you
            to get clarity over your future actions and make the right choices.
        </h1>

        <div className="grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    {/* Personality Card */}
    <div>
    {data.personality && (<>
        <div className="bg-blue-50 mb-3 p-4 shadow-md rounded-lg"
                style={{
                    fontWeight:"600",
                    fontSize:"32px"
                }}>Personality</div>

    <div className="card h-[470px] bg-blue-50 shadow-md rounded-lg p-4 hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out"
                >   
        <div className="flex flex-col gap-10 mt-2"
        >
            <ul
            style={{
                fontWeight:"bold",
                fontSize:"22px"
            }}>
          {data.personality.split(',').map((item, index) => {
            
            return (
              <li
                key={index}
                className={`mb-2 hover:bg-[#e1f0fc] p-3 py-6 text-black py-2 hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out rounded-md `}
              >
               <CircleTwoToneIcon sx={{ marginRight:"4px",fontSize:"16px", color:"black"}} /> {item.trim()}
              </li>
            );
          })}
          </ul>
        </div>
      </div>
      </>
    )}
    </div>

            {/* Interest Cards */}
            <div>
            {data.interest && (
                <>
            
                <h2 className="bg-green-50 mb-3 p-4 shadow-md rounded-lg"
                style={{
                    fontWeight:"600",
                    fontSize:"32px"
                }}>Interest</h2>

<div className="card bg-green-50 h-[470px] shadow-md rounded-lg p-4 hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
                <div className=" flex flex-col gap-10 mt-2"
                style={{
                    
                }}>
                    <ul
            style={{
                fontWeight:"bold",
                fontSize:"22px"
            }}>
                {data.interest.map((item, index) => (
                    <li
                    key={index}
                    className=" p-3 mb-2 hover:bg-[#dcf2de] text-black py-6 hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out rounded-md"
                    >
                   <CircleTwoToneIcon sx={{ marginRight:"4px", fontSize:"16px"}} /> {item}
                    </li>
                ))}
                </ul>
                </div>
            </div>
            </>
            )}
            
            </div>
<div>
            {/* Value Cards */}
            {data.value && (
                <>
                 <h2 className="bg-yellow-50 mb-3 p-4 shadow-md rounded-lg"
                 style={{
                     fontWeight:"600",
                     fontSize:"32px"
                 }}>Values</h2>
            <div className="value card h-[470px] bg-yellow-50 shadow-md rounded-lg p-4 hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
               
                <div className="flex flex-col gap-20 mt-2">
                    <ul
            style={{
                fontWeight:"bold",
                fontSize:"22px"
            }}>
                {data.value.map((item, index) => (
                    <li
                    key={index}
                    className=" mb-2 hover:bg-[#faf7d7]  p-3 text-black py-6 rounded-md hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out"
                    >
                    <CircleTwoToneIcon sx={{ marginRight:"4px",fontSize:"16px"}} /> {item}
                    </li>
                ))}
                </ul>
                </div>
            </div>
            </>
            )}
            </div>
        </div>
        </div>

      <Footer />
    </>
  );
};

export default ReportPage;
